module.exports = __webpack_public_path__ + "static/mobile-app-img-1-706a083aa28718b5e3f34aa8e83e19ad.png";